<div
  class="element-wrapper {{ elementActionsKeyRoot }} {{ elementActionsKey }} {{ listKey }}"
  [ngStyle]="wrapperStyles"
>
  <div class="header">
    <blaze-element-filter-header
      (addButtonClick)="onAddNewRow($event)"
      [addButtonBlocked]="!itemAddEnabled"
      [addButtonCssClasses]="getActionClasses(itemAdd.styleSheetTarget ?? itemAdd.styleSheetId)"
      [addButtonEnabled]="itemAddEnabled"
      [addButtonLabel]="itemAdd.label"
      [fontColor]="props?.style?.general?.heading?.color1"
      [labelEnabled]="labelEnabled"
      [labelFontFamily]="props?.style?.titleBlock?.fontFamily"
      [labelFontSize]="props?.style?.titleBlock?.fontSize"
      [labelFontStyle]="props?.style?.titleBlock?.fontStyle"
      [labelFontWeight]="props?.style?.titleBlock?.fontWeight"
      [labelIconAlign]="props?.content?.title?.iconPosition"
      [labelIconSize]="props?.style?.titleBlock?.iconSize"
      [labelIconColor]="props?.content?.title?.iconColor?.color1"
      [labelIcon]="icon"
      [labelTextAlign]="props?.content?.title?.align"
      [labelText]="labelText"
      [searchAndFilters]="props?.content?.searchAndFilters"
      [slots]="slots"
    >
      @let visibleBulkActions = elementDataActions.visibleBulkActions$ | async;
      @if (visibleBulkActions?.length) {
        <ng-container
          [ngTemplateOutlet]="
            elementDataActions.bulkActionsGrouped ? bulkActionsGroupedTpl : bulkActionsTpl
          "
          [ngTemplateOutletContext]="{
            $implicit: undefined,
            actions: visibleBulkActions,
            cy: 'ListElement:bulk-actions',
            actionsHaveIcons: elementDataActions.bulkActionsHaveIcons,
            isBulk: true,
          }"
        />
      }
    </blaze-element-filter-header>
  </div>

  @if (isListEmpty && (isPending$ | async) === false) {
    <div class="list-notification empty" [ngStyle]="elementStyles">
      <span>{{ noDataMessage }}</span>
    </div>
  }
  @if (!isListEmpty && noFieldBindingsSet) {
    <div class="list-notification no-bindings" [ngStyle]="elementStyles">
      <span>List has no mapped fields yet</span>
    </div>
  }
  <blaze-scroller
    #blazeScroller="blazeScroller"
    (mousedown)="markEventAsHandled($event)"
    (scroll)="updateListScroll($event)"
    [hideScrollX]="isSwipingMode"
    [ngStyle]="listContainerStyles"
    [scrollSnapDirection]="isSwipingMode ? 'x' : 'none'"
  >
    <div
      #listContainer
      (fetchData)="loadMoreData()"
      [class.has-item-click]="itemClickAction"
      [class.has-link]="hasRelatedElements?.()"
      [class.has-checks]="!elementDataActions.singleSelect()"
      [class.has-indicator]="indicatorEnabled"
      [class.has-indicator-left]="indicatorEnabled && indicatorAlignH === 'left'"
      [class.has-indicator-right]="indicatorEnabled && indicatorAlignH === 'right'"
      [class.mobile-scroll-mode]="isMobileScrollMode"
      [class.no-image]="!isImageFieldSet"
      [class.swiping-mode]="isSwipingMode"
      [disabled]="!paginationProps.isServerSide || !paginationProps.enabled"
      [hidden]="isListEmpty || noFieldBindingsSet"
      [scrollDetectionMethod]="scrollingDetectionMethod"
      [scrollingElement]="blazeScroller.getViewport()"
      blazeInfiniteScroll
      class="list-container direction-{{ listDirection }} layout-{{ listLayoutMode }} actions-{{
        actionsDisplayMode
      }} flavor-{{ listFlavor }} image-shape-{{ imageProps?.shape }} image-behavior-{{
        imageProps?.behavior
      }}"
    >
      <div #list class="list" [ngStyle]="listStyles">
        @let context =
          {
            items: dataConnection$ | async,
            customFields: (runtimeCustomFields$ | async) ?? [],
            visibleRowCustomFields: visibleRowCustomFields$ | async,
            visibleRowActions: elementDataActions.visibleRowActions$ | async,
            conditionalFormatter: (conditionalFormatter$ | async),
          };
        @let isCustomFlavor = listFlavor === 'custom';
        @for (item of context.items; let itemIndex = $index; track $index) {
          @let conditionalFormat = context.conditionalFormatter?.(item);
          <div
            #infiniteScrollItem
            class="element"
            [class.selected]="selection.isSelected(item)"
            [ngClass]="conditionalFormat ? 'list-cf-' + conditionalFormat.id : ''"
            [ngStyle]="elementStyles"
            data-cy="ListElement:element"
            (click)="onRowClick($event, item)"
          >
            <div class="element-container hover-parent">
              @if (!elementDataActions.singleSelect() && !isCustomFlavor) {
                <ng-template
                  [ngTemplateOutlet]="itemSelectTpl"
                  [ngTemplateOutletContext]="{ $implicit: item }"
                />
              }
              @if (isImageFieldSet && !isCustomFlavor) {
                <div class="image-container">
                  <blaze-image-column-value
                    [emptyThumbnail]="imageProps?.emptyThumbnail"
                    [fillHorizontally]="true"
                    [imageProps]="imageProps"
                    [value]="item | dataRowFieldValuePipe: imageField"
                    class="image"
                    errorIconSize="48px"
                  />
                </div>
              }
              @if (
                listFlavor === 'list' &&
                (isHeadingFieldSet ||
                  isDescriptionFieldSet ||
                  context.customFields.length ||
                  actions.length)
              ) {
                <div class="well">
                  @if (isHeadingFieldSet) {
                    <h2 class="heading" [ngStyle]="headingStyles">
                      {{
                        item
                          | dataRowFieldValuePipe: headingField
                          | formatValue: headingFieldFormat : headingFieldFormatOptions
                      }}
                    </h2>
                  }
                  @if (isDescriptionFieldSet) {
                    <div class="description" [ngStyle]="descriptionStyles">
                      <div class="content" [class.mobile]="viewportMode === 'mobile'">
                        {{
                          item
                            | dataRowFieldValuePipe: descriptionField
                            | formatValue: descriptionFieldFormat : descriptionFieldFormatOptions
                        }}
                      </div>
                    </div>
                  }

                  @if (context.customFields.length > 0) {
                    <div class="custom-fields">
                      <ng-container
                        *ngTemplateOutlet="
                          customFields;
                          context: {
                            item,
                            context,
                            itemIndex,
                            visibleRowCustomFields: context.visibleRowCustomFields,
                          }
                        "
                      />
                    </div>
                  }

                  @if (actions.length) {
                    <div class="actions -mx-8" [ngStyle]="actionsContainerStyles">
                      <ng-container
                        [ngTemplateOutlet]="actionsGrouped ? actionsGroupedTpl : actionsListedTpl"
                        [ngTemplateOutletContext]="{
                          $implicit: item,
                          itemIndex: itemIndex,
                          visibleRowActions: context.visibleRowActions,
                        }"
                      />
                    </div>
                  }
                </div>
              }

              @if (listFlavor === 'notification') {
                <div class="well">
                  <div class="header">
                    <div class="message-container" [ngStyle]="descriptionStyles">
                      @if (nameField) {
                        <span class="name" [ngStyle]="headingStyles">
                          {{ item | dataRowFieldValuePipe: nameField | formatValue: 'text' }}
                        </span>
                      }
                      @if (messageField) {
                        <span class="message">
                          {{ item | dataRowFieldValuePipe: messageField | formatValue: 'text' }}
                        </span>
                      }
                    </div>
                    @if (canMarkAsRead && item[isUnreadField]) {
                      <span class="read-dot"></span>
                    }
                  </div>
                  @if (context.customFields.length > 0) {
                    <div class="custom-fields">
                      <ng-container
                        *ngTemplateOutlet="
                          customFields;
                          context: {
                            item,
                            context,
                            itemIndex,
                            visibleRowCustomFields: context.visibleRowCustomFields,
                          }
                        "
                      />
                    </div>
                  }
                  @if (actions.length) {
                    <div class="actions" [ngStyle]="actionsContainerStyles">
                      <ng-container
                        [ngTemplateOutlet]="actionsGrouped ? actionsGroupedTpl : actionsListedTpl"
                        [ngTemplateOutletContext]="{
                          $implicit: item,
                          itemIndex: itemIndex,
                          visibleRowActions: context.visibleRowActions,
                        }"
                      />
                    </div>
                  }
                  <div class="footer">
                    <span>
                      @if (timestampField) {
                        <span class="timestamp" [ngStyle]="softStyles">
                          {{
                            item
                              | dataRowFieldValuePipe: timestampField
                              | formatValue: 'datetime' : { dateFormat: "PP' at 'h:mmaaa" }
                          }}
                        </span>
                      }
                    </span>
                    @if (canMarkAsRead && item[isUnreadField]) {
                      <span class="mark-as-read">
                        <a href="#" (click)="markNotificationAsRead($event, item)">Mark as Read</a>
                      </span>
                    }
                  </div>
                </div>
              }

              @if (listFlavor === 'subscription-plan') {
                <div class="well">
                  @if (titleField) {
                    <div class="title">
                      {{ item | dataRowFieldValuePipe: titleField | formatValue: 'text' }}
                    </div>
                  }

                  @if (priceField && priceColumn) {
                    <div class="price">
                      {{ item | dataRowFieldValuePipe: priceField | numberFormat: priceColumn }}
                    </div>
                  }

                  @if (bulletListField) {
                    <ul class="bullet-list" [ngStyle]="descriptionStyles">
                      @for (
                        bullet of $any(
                          item | dataRowFieldValuePipe: bulletListField | formatValue: 'tag'
                        );
                        track bullet
                      ) {
                        <li>
                          @if (props?.content?.subscriptionPlan?.bulletIcon) {
                            <mat-icon [svgIcon]="props?.content?.subscriptionPlan?.bulletIcon!" />
                          }
                          <span>{{ bullet }}</span>
                        </li>
                      }
                    </ul>
                  }

                  @if (context.customFields.length > 0) {
                    <div class="custom-fields">
                      <ng-container
                        *ngTemplateOutlet="
                          customFields;
                          context: {
                            item,
                            context,
                            itemIndex,
                            visibleRowCustomFields: context.visibleRowCustomFields,
                          }
                        "
                      />
                    </div>
                  }
                  @if (actions.length) {
                    <div class="actions" [ngStyle]="actionsContainerStyles">
                      <ng-container
                        [ngTemplateOutlet]="actionsGrouped ? actionsGroupedTpl : actionsListedTpl"
                        [ngTemplateOutletContext]="{
                          $implicit: item,
                          itemIndex: itemIndex,
                          visibleRowActions: context.visibleRowActions,
                        }"
                      />
                    </div>
                  }
                </div>
              }

              @if (listFlavor === 'e-commerce') {
                <div class="well">
                  @if (itemNameField) {
                    <div class="item-name">
                      {{ item | dataRowFieldValuePipe: itemNameField | formatValue: 'text' }}
                    </div>
                  }

                  @if (itemDescriptionField) {
                    <div class="item-description" [ngStyle]="descriptionStyles">
                      {{ item | dataRowFieldValuePipe: itemDescriptionField | formatValue: 'text' }}
                    </div>
                  }

                  @if (itemPriceField) {
                    <div class="price-container">
                      @if (itemPriceField && itemPriceColumn) {
                        <span class="item-price" [ngStyle]="descriptionStyles">
                          {{
                            item
                              | dataRowFieldValuePipe: itemPriceField
                              | numberFormat: itemPriceColumn
                          }}
                        </span>
                      }

                      @if (originalPriceField && originalPriceColumn && showOriginalPrice(item)) {
                        <span class="original-price" [ngStyle]="softStyles">
                          {{
                            item
                              | dataRowFieldValuePipe: originalPriceField
                              | numberFormat: originalPriceColumn
                          }}
                        </span>
                      }
                    </div>
                  }

                  @if (badgeField && item[badgeField]) {
                    <div class="badge">
                      {{ item | dataRowFieldValuePipe: badgeField | formatValue: 'text' }}
                    </div>
                  }
                  @if (item[ratingField]) {
                    <be-list-element-rating
                      class="rating"
                      [value]="item[ratingField]"
                      [votes]="item[ratingVotesField]"
                    />
                  }

                  @if (calloutField) {
                    <div class="callout">
                      {{ item | dataRowFieldValuePipe: calloutField | formatValue: 'text' }}
                    </div>
                  }

                  @if (context.customFields.length > 0) {
                    <div class="custom-fields">
                      <ng-container
                        *ngTemplateOutlet="
                          customFields;
                          context: {
                            item,
                            context,
                            itemIndex,
                            visibleRowCustomFields: context.visibleRowCustomFields,
                          }
                        "
                      />
                    </div>
                  }

                  @if (actions.length) {
                    <div class="actions" [ngStyle]="actionsContainerStyles">
                      <ng-container
                        [ngTemplateOutlet]="actionsGrouped ? actionsGroupedTpl : actionsListedTpl"
                        [ngTemplateOutletContext]="{
                          $implicit: item,
                          itemIndex: itemIndex,
                          visibleRowActions: context.visibleRowActions,
                        }"
                      />
                    </div>
                  }
                </div>
              }
              @if (indicatorEnabled) {
                <div
                  class="icon-indicator indicator-h-{{ indicatorAlignH }} indicator-v-{{
                    indicatorAlignV
                  }}"
                  data-cy="ListElement:iconIndicator"
                >
                  <mat-icon [svgIcon]="indicatorIcon" />
                </div>
              }

              @if (isCustomFlavor) {
                <blaze-custom-template-renderer
                  [code]="(customTemplateCode$ | async) ?? ''"
                  [context]="item"
                />
              }
            </div>
          </div>
        }
      </div>
    </div>
  </blaze-scroller>
  <div class="pagination mt-16" [hidden]="isPaginationHidden">
    <blaze-paginator
      blazeClickable
      [serverSide]="paginationProps.isServerSide"
      [sPageIndex]="paginationProps.pageIndex"
      [sPageSize]="paginationProps.pageSize"
      [paginationState]="paginationProps.state"
      [sTotalCount]="cachedTotalRowsCount || dataRowsCount"
      [hidePageCount]="!cachedTotalRowsCount"
      [backwardPaginationSupported]="paginationProps.backwardPaginationSupported"
      [loading]="paginationPending$ | async"
      (page)="onPage($event)"
    />
  </div>

  @if (isSwipingMode) {
    <div class="mobile-pagination-wrapper">
      <blaze-mobile-pagination
        [itemsCount]="(dataConnection$ | async)?.length ?? 0"
        [selectedIndex]="(currentMobileListItemPageIndex$ | async) ?? 0"
        [color]="mobilePaginationColor"
        [selectedColor]="mobilePaginationSelectedColor"
      />
    </div>
  }
</div>

<ng-template
  #customFields
  let-item="item"
  let-context="context"
  let-itemIndex="itemIndex"
  let-visibleRowCustomFields="visibleRowCustomFields"
>
  @for (field of visibleRowCustomFields?.[itemIndex]; let index = $index; track field) {
    <div class="custom-field-item label-{{ field.labelBehavior }} format-{{ field.displayFormat }}">
      @if (field.label) {
        <div class="label" [ngStyle]="headingStyles">{{ field.label }}</div>
      }
      <div class="value" [ngStyle]="descriptionStyles">
        @if (field.columnName) {
          <ng-container
            [ngTemplateOutlet]="getTemplateFormat(field.displayFormat) ?? null"
            [ngTemplateOutletContext]="{ $implicit: item, field, index }"
          />
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #actionBtnTpl let-action let-item="item">
  @let showInlineLabel = action.showInlineLabel !== false;
  <button
    (click)="onAction({ event: $event, action, dataRow: item, actionId: action.actionId })"
    [class.icon-only]="!showInlineLabel && action.icon"
    [class.icon-right]="action.iconPosition === 'right'"
    [disabled]="
      action
        | isActionDisabled
          : elementDataActions.pendingActions()
          : elementDataActions.disableActionWhenPending()
    "
    [ngClass]="getActionClasses(action?.styleSheetTarget ?? action?.styleSheetId)"
    class="action-item"
    data-cy="ListElement:itemAction"
  >
    <blaze-element-loading-indicator
      [isVisible]="
        (action | isActionPending: elementDataActions.pendingActions()) && !!action.showLoader
      "
      [mode]="'theme'"
    />
    @if (action.icon) {
      <mat-icon [svgIcon]="action.icon" />
    }
    @if (showInlineLabel || !action.icon) {
      {{ action.label }}
    }
  </button>
</ng-template>

<ng-template
  #actionsListedTpl
  let-item
  let-itemIndex="itemIndex"
  let-visibleRowActions="visibleRowActions"
>
  @for (action of visibleRowActions?.[itemIndex]; track action) {
    <ng-container *ngTemplateOutlet="actionBtnTpl; context: { $implicit: action, item: item }" />
  }
</ng-template>

<ng-template #actionsGroupedTpl let-item let-itemIndex="itemIndex">
  @let visibleRowActions = (elementDataActions.visibleRowActions$ | async) ?? [[]];
  @if (visibleRowActions[itemIndex].length) {
    <button blazeIconButton [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
      <mat-icon svgIcon="icon_more_h_24" />
    </button>
  }
  <mat-menu #actionsMenu="matMenu" xPosition="before" class="bd-menu-actions b-bl-am-dd">
    <ng-template matMenuContent>
      @for (action of visibleRowActions[itemIndex]; track $index) {
        <button
          (click)="onAction({ event: $event, action, dataRow: item, actionId: action.actionId })"
          [class.icon-right]="action.iconPosition === 'right'"
          [disabled]="
            action
              | isActionDisabled
                : elementDataActions.pendingActions()
                : elementDataActions.disableActionWhenPending()
          "
          [style.color]="actionsColor"
          blazeClickable
          disableRipple
          mat-menu-item
        >
          @if (action.icon) {
            <mat-icon [svgIcon]="action.icon" />
          }
          {{ action.label }}
        </button>
      }
    </ng-template>
  </mat-menu>
</ng-template>

<!-- #region cells-->

<!-- cell: text -->
<ng-template #textCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'text' }}
</ng-template>

<!-- cell: currency -->
<ng-template #currencyCellTpl let-item let-field="field">
  {{
    item
      | dataRowFieldValuePipe: field.columnName
      | formatValue: 'currency' : { precision: field.precision, currency: field.currency }
  }}
</ng-template>

<!-- cell: number -->
<ng-template #numberCellTpl let-item let-field="field">
  {{
    item
      | dataRowFieldValuePipe: field.columnName
      | formatValue: 'number' : { precision: field.precision }
  }}
</ng-template>

<!-- cell: date -->
<ng-template #dateCellTpl let-item let-field="field">
  {{
    item
      | dataRowFieldValuePipe: field.columnName
      | formatValue: 'date' : { dateFormat: field.dateFormat }
  }}
</ng-template>

<!-- cell: datetime -->
<ng-template #datetimeCellTpl let-item let-field="field">
  {{
    item
      | dataRowFieldValuePipe: field.columnName
      | formatValue: 'datetime' : { dateTimeFormat: field.dateTimeFormat }
  }}
</ng-template>

<!-- cell: time -->
<ng-template #timeCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'time' }}
</ng-template>

<!-- cell: duration -->
<ng-template #durationCellTpl let-item let-field="field">
  {{
    item
      | dataRowFieldValuePipe: field.columnName
      | formatValue: 'duration' : { durationFormat: field.duration || 'h:mm' }
  }}
</ng-template>

<!-- cell: checkbox -->
<ng-template #checkboxCellTpl let-item let-field="field">
  @let isChecked = item | dataRowFieldValuePipe: field.columnName | formatValue: 'checkbox';
  <mat-icon
    class="col-boolean"
    [class.checked]="isChecked"
    svgIcon="{{ isChecked ? 'icon_boolean_on_24' : 'icon_boolean_off_24' }}"
  />
</ng-template>

<!-- cell: image -->
<ng-template #imageCellTpl let-item let-field="field">
  @if (item | dataRowFieldValuePipe: field.columnName; as value) {
    <img
      [src]="value"
      alt=""
      imgError="assets/images/icon-image-32.svg"
      class="col-img"
      loading="lazy"
    />
  }
</ng-template>

<!-- cell: percentage -->
<ng-template #percentageCellTpl let-item let-field="field">
  {{
    item
      | dataRowFieldValuePipe: field.columnName
      | formatValue: 'percentage' : { precision: field.precision }
  }}
</ng-template>

<!-- cell: heading -->
<ng-template #headingCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'text' }}
</ng-template>

<!-- cell: paragraph -->
<!-- Keep this in one line! -->
<ng-template #paragraphCellTpl let-item let-field="field"
  >{{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'text' }}
</ng-template>

<!-- cell: richText -->
<ng-template #richTextCellTpl let-item let-field="field">
  <span
    [innerHTML]="(item | dataRowFieldValuePipe: field.columnName) ?? '' | securityTrust: 'html'"
  ></span>
</ng-template>

<!-- cell: markdown -->
<ng-template #markdownCellTpl let-item let-field="field">
  <span [innerHTML]="(item | dataRowFieldValuePipe: field.columnName) ?? '' | markdown"></span>
</ng-template>

<!-- cell: email -->
<ng-template #emailCellTpl let-item let-field="field">
  <span (click)="columnTypeClicked('email', item?.[field.columnName])">{{
    item | dataRowFieldValuePipe: field.columnName
  }}</span>
</ng-template>

<!-- cell: url -->
<ng-template #urlCellTpl let-item let-field="field">
  <span (click)="columnTypeClicked('url', item?.[field.columnName])">{{
    item | dataRowFieldValuePipe: field.columnName
  }}</span>
</ng-template>

<!-- cell: phoneNumber -->
<ng-template #phoneNumberCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'phoneNumber' }}
</ng-template>

<!-- cell: timezone -->
<ng-template #timezoneCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'text' }}
</ng-template>

<!-- cell: zipcode -->
<ng-template #zipcodeCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'text' }}
</ng-template>

<!-- cell: geopoint -->
<ng-template #geopointCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'geopoint' }}
</ng-template>

<!-- cell: secureText -->
<ng-template #secureTextCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'secureText' }}
</ng-template>

<!-- cell: tag -->
<ng-template #tagCellTpl let-item let-field="field" let-index="index">
  <blaze-tags-column-value
    [value]="item | dataRowFieldValuePipe: field.columnName"
    [palette]="tagConfig[index]?.palette"
    [order]="tagConfig[index]?.order"
  />
</ng-template>

<!-- cell: file -->
<ng-template #fileCellTpl let-item let-field="field">
  <blaze-file-column-value
    class="files"
    [value]="item | dataRowFieldValuePipe: field.columnName"
    [isSecure]="isFieldSecure(field.columnName)"
  />
</ng-template>

<!-- cell: signature -->
<ng-template #signatureCellTpl let-item let-field="field">
  <blaze-signature-column-value
    [signature]="$any(item | dataRowFieldValuePipe: field.columnName)"
  />
</ng-template>

<!-- #endregion -->

<ng-template #bulkActionsTpl let-item let-actions="actions">
  @for (action of actions; track $index) {
    <button
      (click)="onAction({ event: $event, action, isBulkAction: true, actionId: action.actionId })"
      [class.flex-row-reverse]="action.iconPosition === 'right'"
      [disabled]="
        !elementDataActions.selectionCount ||
        (action
          | isActionDisabled
            : elementDataActions.pendingActions()
            : elementDataActions.disableActionWhenPending())
      "
      [ngClass]="getActionClasses(action.styleSheetTarget ?? action.styleSheetId)"
      attr.data-cy="TableElement:bulkAction:{{ action.label }}"
      blazeClickable
      blazeIconButton="bat"
      blazeIconButtonSize="xl"
      blazeTooltip="{{
        `${action.label}${elementDataActions.selectionCount ? '' : (action.label ? ' - ' : '') + 'Select rows to enable actions'}`
      }}"
      class="efh-action-btn relative"
    >
      <blaze-element-loading-indicator
        [isVisible]="
          action
            | isActionDisabled
              : elementDataActions.pendingActions()
              : elementDataActions.disableActionWhenPending()
        "
        [mode]="'theme'"
      />
      @if (action.icon) {
        <span class="icon">
          <mat-icon [svgIcon]="action.icon" />
        </span>
      }
      @if (action.showInlineLabel || !action.icon) {
        <span>{{ action.label | textLimit: 25 }}</span>
      }
    </button>
  }
</ng-template>

<ng-template
  #bulkActionsGroupedTpl
  let-item
  let-actions="actions"
  let-cy="cy"
  let-actionsHaveIcons="actionsHaveIcons"
>
  <button
    blazeClickable
    blazeIconButton="bat"
    blazeIconButtonSize="xl"
    class="efh-action-btn"
    [matMenuTriggerFor]="menu"
    [attr.data-cy]="cy"
  >
    <mat-icon svgIcon="icon_more_h_24" />
  </button>

  <mat-menu #menu="matMenu" class="bd-menu-actions b-bl-am-dd">
    <ng-template matMenuContent>
      @let isDisabled = !elementDataActions.selectionCount;
      @if (isDisabled) {
        <div class="border-a-12 border-x-0 border-t-0 p-8 text-primary-darker"
          >Select rows to enable actions</div
        >
      }
      @for (action of actions; track $index) {
        <button
          mat-menu-item
          blazeClickable
          [disabled]="isDisabled"
          (click)="onAction({ event: $event, action, dataRow: item, isBulkAction: true, menu })"
        >
          @if (action.icon || actionsHaveIcons) {
            <mat-icon [svgIcon]="action.icon || 'empty'" />
          }
          <span>{{ action.label }}</span>
        </button>
      }
    </ng-template>
  </mat-menu>
</ng-template>

<ng-template #itemSelectTpl let-item>
  @let isSelected = selection.isSelected(item);
  <div class="absolute top-8 right-8" [class.hover-child]="!isSelected">
    <blaze-checkbox
      class="with-theme"
      data-cy="ListElement:SelectRow"
      [checked]="isSelected"
      (click)="$event.stopPropagation()"
      (change)="elementDataActions.toggleSelection(item, value, { select: true })"
    />
  </div>
</ng-template>
